/**
 * Collections Tour Configuration
 *
 * Step-by-step tour guide for the Collections page.
 */

import { filterExistingSteps } from './tourUtils.js';

export const getCollectionsTourSteps = (t) =>
  filterExistingSteps([
    {
      selector: '[data-tour="collections-header"]',
      content: t('tour.collections.header', {
        ns: 'common',
        defaultValue: 'Manage all your invoices and track incoming payments here.',
      }),
      position: 'bottom',
    },
    {
      selector: '[data-tour="collections-filters"]',
      content: t('tour.collections.filters', {
        ns: 'common',
        defaultValue: 'Filter by status or search invoices. Click "Create Invoice" to add a new invoice.',
      }),
      position: 'bottom',
    },
    {
      selector: '[data-tour="collections-table"]',
      content: t('tour.collections.table', {
        ns: 'common',
        defaultValue: 'View invoice details: customer, amount, status, and due date. Click any row for more options.',
      }),
      position: 'top',
    },
  ]);
